import type { InsightMeta } from "@/components/insights/InsightShell";
import {
  compareQuotationsMeta,
  CompareQuotationsBody,
} from "@/components/insights/CompareIsoQuotations";
import { certificateScopeMeta, CertificateScopeBody } from "@/components/insights/CertificateScope";
import { costProcessIraqMeta, CostProcessIraqBody } from "@/components/insights/CostProcessIraq";
import {
  accreditedVsNonMeta,
  AccreditedVsNonBody,
} from "@/components/insights/AccreditedVsNonAccredited";
import {
  isoRecognizedIraqMeta,
  IsoRecognizedIraqBody,
} from "@/components/insights/IsoRecognizedInIraq";
import { iso29001VsApiQ1Meta, Iso29001VsApiQ1Body } from "@/components/insights/Iso29001VsApiQ1";
import { whichIsoMeta, WhichIsoBody } from "@/components/insights/WhichIsoStandard";
import { trustedBodyMeta, TrustedBodyBody } from "@/components/insights/TrustedCertificationBody";
import { lifecycleMeta, LifecycleBody } from "@/components/insights/PostCertificationLifecycle";
import {
  consultantMeta,
  ConsultantBody,
} from "@/components/insights/ConsultantVsCertificationBody";

export interface InsightEntry {
  meta: InsightMeta;
  Body: () => React.ReactElement;
}

// Registry of insight/guide articles, in display order. Add new articles here.
const registry: InsightEntry[] = [
  { meta: compareQuotationsMeta, Body: CompareQuotationsBody },
  { meta: certificateScopeMeta, Body: CertificateScopeBody },
  { meta: costProcessIraqMeta, Body: CostProcessIraqBody },
  { meta: trustedBodyMeta, Body: TrustedBodyBody },
  { meta: lifecycleMeta, Body: LifecycleBody },
  { meta: consultantMeta, Body: ConsultantBody },
  { meta: accreditedVsNonMeta, Body: AccreditedVsNonBody },
  { meta: isoRecognizedIraqMeta, Body: IsoRecognizedIraqBody },
  { meta: iso29001VsApiQ1Meta, Body: Iso29001VsApiQ1Body },
  { meta: whichIsoMeta, Body: WhichIsoBody },
];

export const insights: Record<string, InsightEntry> = Object.fromEntries(
  registry.map((e) => [e.meta.slug, e]),
);

/** Article list in display order (for the /insights index). */
export const insightList = registry;

export function getInsight(slug: string): InsightEntry | undefined {
  return insights[slug];
}

export const insightSlugs = registry.map((e) => e.meta.slug);
